module.exports = __webpack_public_path__ + "media/images/banners/4-f5297809229af23e13fc7d257fc5ff73.jpg";